import { get } from 'lodash';
import { createFetchAction } from '../helpers/fetch';
import { getToken, logout, buildApiUrl } from '../../helpers';

// Actions
export const GET_CREATE_TEMPLATE_URL = 'GET_CREATE_TEMPLATE_URL';
export const GET_EDIT_TEMPLATE_URL = 'GET_EDIT_TEMPLATE_URL';

// Action Creators
export function getCreateTemplateUrl(payload, companyId, category, title) {
  const token = getToken();
  const { encodedFile, file: { name } } = payload;
  return createFetchAction(GET_CREATE_TEMPLATE_URL, {
    url: `${buildApiUrl(token, companyId)}/templates`,
    method: 'POST',
    body: JSON.stringify({
      file: encodedFile,
      fileName: name,
      signerRoles: ['OnboardingSignatory'],
      category,
      title,
      // We're currently hardcoding `message` since HelloSign needs this value in
      // order to skip the title/message setup step. Message is only used when
      // emailing signature requests, functionality we're not currently utilizing.
      message: title,
    }),
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  }, 'GETTING_CREATE_TEMPLATE_URL', {
    fallbackAction: logout,
    errorCodes: [401],
  });
}

export function getEditTemplateUrl(templateId) {
  const token = getToken();
  const companyId = get(window, 'asure.appSettings.selectedCompany.companyId');
  return createFetchAction(GET_EDIT_TEMPLATE_URL, {
    url: `${buildApiUrl(token, companyId)}/templates/${templateId}/edit-url`,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  }, 'GETTING_CREATE_TEMPLATE_URL', {
    fallbackAction: logout,
    errorCodes: [401],
  });
}

const INITIAL_STATE = {
  createTemplate: {
    clientId: undefined,
    template: {
      editUrl: undefined,
      id: undefined,
    },
  },
  editTemplate: {
    clientId: undefined,
    url: undefined,
  },
};

export function templates(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_CREATE_TEMPLATE_URL: {
      const { payload: createTemplate } = action;
      return {
        ...state,
        createTemplate,
      };
    }
    case GET_EDIT_TEMPLATE_URL: {
      const { payload: editTemplate } = action;
      return {
        ...state,
        editTemplate,
      };
    }
    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/modules/templates/templates.js